/*
  Remembers the products a shopper has looked at, newest first, so the cart
  page can show a "Recently viewed" row (sections/cart-recently-viewed.liquid).
  Stored in the shopper's own browser only. Kept first in this file and inside
  a try/catch so nothing else here can stop it, and it can stop nothing else.
*/
(function () {
  try {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return;
    var handle = decodeURIComponent(match[1]);
    var key = 'beauvoir:recently-viewed';
    var list = [];
    try {
      list = JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (error) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];
    list = list.filter(function (item) {
      return item !== handle;
    });
    list.unshift(handle);
    window.localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
  } catch (error) {
    // Storage blocked (private browsing): the row simply stays empty.
  }
})();

$('.featured-category__itemsd').slick({
 
  centerMode: false,
//   centerPadding: '60px',
  slidesToShow: 6,
  arrows:false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
       

      }
    }
    
  ]
});